"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
function GenerateId() {
    return _.uniqueId();
}
exports.GenerateId = GenerateId;
